// @ts-check
'use strict'
import { Route } from 'react-router-dom'

/** @type {ThemeRoutes} **/
const theme_routes = []

export default theme_routes
